import PropTypes from 'prop-types'

export const PricingCard = ({
  tier,
  subtitle,
  price,
  currency = 'US$',
  period = 'per month',
  features = [],
  highlighted = false,
}) => {
  const cardClasses = highlighted
    ? 'bg-gradient-to-b from-dark-tertiary to-dark-secondary border-gray-600'
    : 'bg-dark-secondary border-dark-border'

  return (
    <div className={`rounded-lg p-6 border ${cardClasses} flex flex-col h-full`}>
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-white mb-2">{tier}</h2>
        {subtitle && <p className="text-sm text-gray-400">{subtitle}</p>}
      </div>

      <div className="space-y-3 flex-grow">
        {features.map((feature, index) => (
          <div key={index} className="text-gray-300 text-sm">
            {feature}
          </div>
        ))}
      </div>

      <div className="text-center mt-8 pt-6 border-t border-dark-border">
        <div className="text-3xl font-bold text-white">
          {price === 0 ? (
            <span>{currency}0</span>
          ) : (
            <span>
              {currency}
              {price}
            </span>
          )}
        </div>
        <div className="text-sm text-gray-400 mt-1">{period}</div>
      </div>
    </div>
  )
}

PricingCard.propTypes = {
  tier: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  price: PropTypes.number.isRequired,
  currency: PropTypes.string,
  period: PropTypes.string,
  features: PropTypes.arrayOf(PropTypes.string),
  highlighted: PropTypes.bool,
}

export default PricingCard
